import React from "react";
import { FormattedMessage } from "react-intl";

export default function NotFound() {
  return (
    <div className="not-found text-center">
      <h3><FormattedMessage id="Sorry, page not found!" defaultMessage="Sorry, page not found!" /></h3>
    </div>
  );
}